/** @jsx jsx */
import { bool, func, object } from 'prop-types'
import { useContext } from 'react'
import { jsx } from 'theme-ui'
import { QuestionStepContext } from '../../../context/QuestionStepContext'
import QuestionSection from '../../common/QuestionSection'

const Generic = props => {
  const { template } = useContext(QuestionStepContext)
  const { questionIsPercentGroupSection } = template
  return (
    <QuestionSection
      {...props}
      hideAllRequiredMessage={questionIsPercentGroupSection}
    />
  )
}

Generic.propTypes = {
  question: object,
  questionHasTooManyAnswers: bool,
  setQuestionHasTooManyAnswers: func,
}

export default Generic
